export default __webpack_public_path__ + "static/ishita-kumar-profile-65f8ca7fd0f8cb5a944daa11e4024bc7.webp";